import React from "react";

const ServicePageSkeleton = () => {
  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="animate-pulse">
        {/* Header section */}
        <div className="sm:flex sm:items-center">
          <div className="sm:flex-auto">
            <div className="h-4 bg-cream-300 rounded w-3/4 mb-2"></div>
          </div>
          <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
            <div className="h-10 bg-cream-300 rounded w-32"></div>
          </div>
        </div>

        {/* Mobile view skeleton */}
        <div className="mt-6 sm:hidden">
          <div className="space-y-4">
            {[1, 2, 3].map((i) => (
              <div
                key={i}
                className="bg-cream-50 rounded-card border border-ink-100 p-4"
              >
                <div className="flex items-start justify-between">
                  <div className="flex items-center min-w-0 flex-1">
                    <div className="size-12 bg-cream-300 rounded-card"></div>
                    <div className="ml-4 min-w-0 flex-1">
                      <div className="h-4 bg-cream-300 rounded w-3/4 mb-2"></div>
                      <div className="h-3 bg-cream-300 rounded w-full"></div>
                    </div>
                  </div>
                  <div className="ml-4">
                    <div className="size-5 bg-cream-300 rounded"></div>
                  </div>
                </div>
                <div className="mt-4 space-y-3">
                  <div className="flex items-center">
                    <div className="w-16 h-3 bg-cream-300 rounded"></div>
                    <div className="ml-2 h-3 bg-cream-300 rounded w-20"></div>
                  </div>
                  <div className="flex items-center">
                    <div className="w-16 h-3 bg-cream-300 rounded"></div>
                    <div className="ml-2 h-3 bg-cream-300 rounded w-16"></div>
                  </div>
                  <div className="flex items-center">
                    <div className="w-16 h-3 bg-cream-300 rounded"></div>
                    <div className="ml-2 h-6 bg-cream-300 rounded w-20"></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Desktop view skeleton */}
        <div className="mt-8 flow-root hidden sm:block">
          <div className="-mx-4 -my-2 overflow-visible sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
              <div className="overflow-visible shadow-hairline border border-ink-100 sm:rounded-card">
                <div className="bg-cream-100 px-4 py-3.5 sm:px-6">
                  <div className="grid grid-cols-5 gap-4">
                    <div className="h-4 bg-cream-300 rounded"></div>
                    <div className="h-4 bg-cream-300 rounded"></div>
                    <div className="h-4 bg-cream-300 rounded"></div>
                    <div className="h-4 bg-cream-300 rounded"></div>
                    <div className="h-4 bg-cream-300 rounded"></div>
                  </div>
                </div>
                <div className="bg-white divide-y divide-ink-100">
                  {[1, 2, 3].map((i) => (
                    <div key={i} className="px-4 py-4 sm:px-6">
                      <div className="grid grid-cols-5 gap-4 items-center">
                        <div className="flex items-center">
                          <div className="size-11 bg-cream-300 rounded-card"></div>
                          <div className="ml-4">
                            <div className="h-4 bg-cream-300 rounded w-24 mb-2"></div>
                            <div className="h-3 bg-cream-300 rounded w-32"></div>
                          </div>
                        </div>
                        <div className="h-4 bg-cream-300 rounded w-16"></div>
                        <div className="h-4 bg-cream-300 rounded w-20"></div>
                        <div className="h-6 bg-cream-300 rounded w-20"></div>
                        <div className="flex justify-end">
                          <div className="size-5 bg-cream-300 rounded"></div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicePageSkeleton;
